import {
  ChartCard,
  ChartNoDataFound,
  placeholder,
  useEffect,
  useState,
} from "@";
import { useProjectsVerificationsQuery } from "../utils/queries.js";

const ProjectsVerifications = () => {
  const [data, setData] = useState([]);
  const [searchDuration, setSearchDuration] = useState(3);

  // Use React Query to fetch projects verifications data
  const { data: projectsData } = useProjectsVerificationsQuery(searchDuration);

  // Fetch data based on the duration
  const fetchData = (value) => {
    setSearchDuration(value);
  };

  useEffect(() => {
    if (projectsData?.mostVerifiedProjects) {
      setData(projectsData.mostVerifiedProjects);
    }
  }, [projectsData]);

  return (
    <>
      <ChartCard
        title="توثيق المشاريع "
        searchDurationUpdated={fetchData}
        searchDuration={searchDuration}
      >
        {data?.length > 0 ? (
          <div className="relative mt-3 overflow-x-auto">
            <table className="w-full text-sm text-gray-500 dark:text-gray-400">
              <thead className="border-b border-gray-100 text-sm text-gray-500 dark:border-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-3 py-3"></th>
                  <th scope="col" className="px-1 py-3 text-center">
                    عدد التوثيقات
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((project, i) => (
                  <tr key={i} className="text-gray-500 dark:text-gray-400">
                    <th className="px-3 py-2">
                      <div className="flex items-center justify-start">
                        <img
                          alt={project.projectName}
                          src={placeholder}
                          className="h-12 w-12 rounded-full object-cover"
                        />
                        <h3 className="ms-2 text-sm dark:text-gray-400">
                          {project.projectName}
                        </h3>
                      </div>
                    </th>

                    <th className="px-1 py-2 text-center">
                      {project.verificationsCount}
                    </th>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="h-80">
            <ChartNoDataFound />
          </div>
        )}
      </ChartCard>
    </>
  );
};

export default ProjectsVerifications;
